// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { AssetInfoFragmentDoc } from '../../../projects/assets/AssetPreview.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CompareModeDesignPackageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type CompareModeDesignPackageQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, code?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, order: number, designPackageAbbreviation: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, forDesignPackages: boolean, forDesignUpgrade: boolean, isPlanPackage: boolean, group: { __typename?: 'GlobalOptionGroup', id: string, designPackageTagColor?: string | null | undefined } } }> } };

export type CompareModeDesignPackageTlisQueryVariables = Types.Exact<{
  filter: Types.DesignPackageFinishScheduleFilter;
}>;


export type CompareModeDesignPackageTlisQuery = { __typename?: 'Query', designPackageFinishSchedule: { __typename?: 'DesignPackageFinishSchedulePageResult', entities: Array<{ __typename?: 'TakeoffLineItem', id: string, isDisabledMaterialVariant: boolean, placeholder?: { __typename?: 'TakeoffLineItem', id: string } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined }> } };

export type CompareMode_DesignPackageFragment = { __typename?: 'DesignPackage', id: string, code?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, order: number, designPackageAbbreviation: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, forDesignPackages: boolean, forDesignUpgrade: boolean, isPlanPackage: boolean, group: { __typename?: 'GlobalOptionGroup', id: string, designPackageTagColor?: string | null | undefined } } }> };

export type CompareMode_DesignPackageOptionsFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, order: number, designPackageAbbreviation: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, forDesignPackages: boolean, forDesignUpgrade: boolean, isPlanPackage: boolean, group: { __typename?: 'GlobalOptionGroup', id: string, designPackageTagColor?: string | null | undefined } } };

export type CompareMode_TliFragment = { __typename?: 'TakeoffLineItem', id: string, isDisabledMaterialVariant: boolean, placeholder?: { __typename?: 'TakeoffLineItem', id: string } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export const CompareMode_DesignPackageOptionsFragmentDoc = gql`
    fragment CompareMode_DesignPackageOptions on ReadyPlanOption {
  id
  name
  order
  designPackageAbbreviation
  optionGroup {
    id
    name
    order
    forDesignPackages
    forDesignUpgrade
    isPlanPackage
    group {
      id
      designPackageTagColor
    }
  }
}
    `;
export const CompareMode_DesignPackageFragmentDoc = gql`
    fragment CompareMode_DesignPackage on DesignPackage {
  id
  code
  version {
    id
  }
  costCodes {
    ...Named
  }
  options {
    ...CompareMode_DesignPackageOptions
  }
}
    ${NamedFragmentDoc}
${CompareMode_DesignPackageOptionsFragmentDoc}`;
export const CompareMode_TliFragmentDoc = gql`
    fragment CompareMode_Tli on TakeoffLineItem {
  id
  placeholder {
    id
  }
  targetCombinations {
    id
    name
    options {
      id
    }
  }
  isDisabledMaterialVariant
  materialVariant {
    id
    displayName
    featuredImage {
      id
      asset {
        ...AssetInfo
      }
    }
  }
}
    ${AssetInfoFragmentDoc}`;
export const CompareModeDesignPackageDocument = gql`
    query CompareModeDesignPackage($id: ID!, $versionId: ID!) {
  designPackage(id: $id, versionId: $versionId) {
    ...CompareMode_DesignPackage
  }
}
    ${CompareMode_DesignPackageFragmentDoc}`;

/**
 * __useCompareModeDesignPackageQuery__
 *
 * To run a query within a React component, call `useCompareModeDesignPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareModeDesignPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareModeDesignPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useCompareModeDesignPackageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompareModeDesignPackageQuery, CompareModeDesignPackageQueryVariables> & ({ variables: CompareModeDesignPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompareModeDesignPackageQuery, CompareModeDesignPackageQueryVariables>(CompareModeDesignPackageDocument, options);
      }
export function useCompareModeDesignPackageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompareModeDesignPackageQuery, CompareModeDesignPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompareModeDesignPackageQuery, CompareModeDesignPackageQueryVariables>(CompareModeDesignPackageDocument, options);
        }
export function useCompareModeDesignPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompareModeDesignPackageQuery, CompareModeDesignPackageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompareModeDesignPackageQuery, CompareModeDesignPackageQueryVariables>(CompareModeDesignPackageDocument, options);
        }
export type CompareModeDesignPackageQueryHookResult = ReturnType<typeof useCompareModeDesignPackageQuery>;
export type CompareModeDesignPackageLazyQueryHookResult = ReturnType<typeof useCompareModeDesignPackageLazyQuery>;
export type CompareModeDesignPackageSuspenseQueryHookResult = ReturnType<typeof useCompareModeDesignPackageSuspenseQuery>;
export type CompareModeDesignPackageQueryResult = Apollo.QueryResult<CompareModeDesignPackageQuery, CompareModeDesignPackageQueryVariables>;
export const CompareModeDesignPackageTlisDocument = gql`
    query CompareModeDesignPackageTlis($filter: DesignPackageFinishScheduleFilter!) {
  designPackageFinishSchedule(filter: $filter) {
    entities {
      ...CompareMode_Tli
    }
  }
}
    ${CompareMode_TliFragmentDoc}`;

/**
 * __useCompareModeDesignPackageTlisQuery__
 *
 * To run a query within a React component, call `useCompareModeDesignPackageTlisQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareModeDesignPackageTlisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareModeDesignPackageTlisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCompareModeDesignPackageTlisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompareModeDesignPackageTlisQuery, CompareModeDesignPackageTlisQueryVariables> & ({ variables: CompareModeDesignPackageTlisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompareModeDesignPackageTlisQuery, CompareModeDesignPackageTlisQueryVariables>(CompareModeDesignPackageTlisDocument, options);
      }
export function useCompareModeDesignPackageTlisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompareModeDesignPackageTlisQuery, CompareModeDesignPackageTlisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompareModeDesignPackageTlisQuery, CompareModeDesignPackageTlisQueryVariables>(CompareModeDesignPackageTlisDocument, options);
        }
export function useCompareModeDesignPackageTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompareModeDesignPackageTlisQuery, CompareModeDesignPackageTlisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompareModeDesignPackageTlisQuery, CompareModeDesignPackageTlisQueryVariables>(CompareModeDesignPackageTlisDocument, options);
        }
export type CompareModeDesignPackageTlisQueryHookResult = ReturnType<typeof useCompareModeDesignPackageTlisQuery>;
export type CompareModeDesignPackageTlisLazyQueryHookResult = ReturnType<typeof useCompareModeDesignPackageTlisLazyQuery>;
export type CompareModeDesignPackageTlisSuspenseQueryHookResult = ReturnType<typeof useCompareModeDesignPackageTlisSuspenseQuery>;
export type CompareModeDesignPackageTlisQueryResult = Apollo.QueryResult<CompareModeDesignPackageTlisQuery, CompareModeDesignPackageTlisQueryVariables>;